export const ATTENDANCE_SLIDES = [
  { image: "1.jpg", title: "Informasi Pembuka", checks: [] },
  { image: "2.jpg", title: "Dokumen Identitas Diri", checks: [
    ["slide_2_ktp", "Saya telah membawa KTP atau dokumen penggantinya", "attendance-check-slide2-ktp"],
    ["slide_2_kip", "Saya telah membawa Print Out Kartu KIP Virtual", "attendance-check-slide2-kip"],
  ] },
  { image: "3.jpg", title: "Kelengkapan Formulir Rangkap Tiga", checks: [
    ["slide_3_tanda_terima", "Saya telah membawa FORMULIR TANDA TERIMA - rangkap 3", "attendance-check-slide3-tanda-terima"],
    ["slide_3_surat_pernyataan", "Saya telah membawa SURAT PERNYATAAN - rangkap 3", "attendance-check-slide3-surat-pernyataan"],
    ["slide_3_surat_kuasa", "Saya telah membawa SURAT KUASA - rangkap 3", "attendance-check-slide3-surat-kuasa"],
  ] },
  { image: "4.jpg", title: "Petunjuk Pengisian Dokumen", checks: [] },
  { image: "5.jpg", title: "Panduan Penulisan & Tanda Tangan", checks: [] },
  { image: "6.jpg", title: "Contoh Formulir Bagian 1", notice: "FORMULIR INI AKAN DIBERIKAN DI LOKASI KEGIATAN", checks: [
    ["slide_6_isi_formulir", "Saya sudah mengisi formulir seperti contoh diatas", "attendance-check-slide6"],
  ] },
  { image: "7.png", title: "Contoh Formulir Bagian 2", checks: [
    ["slide_7_isi_formulir", "Saya sudah mengisi formulir seperti contoh diatas", "attendance-check-slide7"],
  ] },
  { image: "8.jpg", title: "Contoh Formulir Bagian 3", checks: [
    ["slide_8_isi_formulir", "Saya sudah mengisi formulir seperti contoh diatas", "attendance-check-slide8"],
  ] },
  { image: "9.jpg", title: "Contoh Formulir Bagian 4", checks: [
    ["slide_9_isi_formulir", "Saya sudah mengisi formulir seperti contoh diatas", "attendance-check-slide9"],
  ] },
  { image: "10.jpg", title: "Penyusunan Formulir & Urutan Berkas", checks: [
    ["slide_10_susun_formulir", "Saya sudah MENYUSUN formulir seperti contoh diatas", "attendance-check-slide10"],
  ] },
  { image: "11.jpg", title: "Konfirmasi Kehadiran di Lokasi & Dokumen Final", checks: [
    ["slide_11_lokasi_antrian", "Saya sudah berada di lokasi, jika saya dipanggil tapi tidak hadir maka saya akan mendapat antrian paling belakang.", "attendance-check-slide11-lokasi"],
    ["slide_11_cek_dokumen", "CEK LAGI! Semua dokumen sudah saya isi", "attendance-check-slide11-dokumen"],
  ] },
];

export const REQUIRED_ATTENDANCE_CHECKS = ATTENDANCE_SLIDES.flatMap((slide) => slide.checks.map(([id]) => id));